export { default } from "./author-bio"